common.View.create('canvas.blocks.sky.callToActionCharlie.Block', {

    onDOMLoad() {
        if (!this.element.find('> div').hasClass('editOrRender')) {
            this.initDisappearAtFooter();
        }
    },

    initDisappearAtFooter() {
        // Define footer element
        let footer = $('footer');

        // Add listener for scroll
        document.addEventListener('scroll', () => {
            // Check if footer is in sight
            if (footer.offset() && footer.offset().top <= (window.scrollY + window.innerHeight)) {
                // Hide element with fade
                this.element.fadeOut('fast');
            } else {
                // Show element with fade
                this.element.fadeIn('fast');
            }
        }, true);

        // Trigger scroll so element gets hidden when page refreshes
        footer.scroll();
    }
});
